__turbopack_context__.v({
  "button": "support-success-popup-module-scss-module__TAr08a__button",
  "content": "support-success-popup-module-scss-module__TAr08a__content",
  "content_wrapper": "support-success-popup-module-scss-module__TAr08a__content_wrapper",
  "dialog_title": "support-success-popup-module-scss-module__TAr08a__dialog_title",
  "header": "support-success-popup-module-scss-module__TAr08a__header",
  "root": "support-success-popup-module-scss-module__TAr08a__root",
  "text": "support-success-popup-module-scss-module__TAr08a__text",
  "thank": "support-success-popup-module-scss-module__TAr08a__thank",
});
